module.exports = __webpack_public_path__ + "static/media/hugo.75b39cca.svg";